import { parseCharacterStream } from './responseParser'

// Build the ordered list of speak descriptors for a beat, matching the segment
// indexing the backend's BeatSpeechResolver uses:
//   - narrative / narrative_response / resolution -> a single segment (index 0)
//   - character_response -> one segment per responding character, in order
//
// `generatedContent` is the same { data, loading, streaming } object the player
// renders. Returns [] when there's nothing speakable yet (still streaming / no
// content), so auto-play simply waits for the next ready beat.
export function buildBeatSpeechQueue({ sessionId, beat, generatedContent }) {
  if (!sessionId || !beat?.id) return []
  const beatId = beat.id
  const mk = (segmentIndex) => ({
    id: `beat:${beatId}:${segmentIndex}`,
    kind: 'beat',
    sessionId,
    beatId,
    segmentIndex,
  })

  const type = beat.beat_type

  if (type === 'narrative') {
    // Authored content; always a single segment.
    return beat.content ? [mk(0)] : []
  }

  // AI beats: need finished (non-streaming) content to be speakable.
  const content = generatedContent
  if (!content || content.loading || content.streaming || !content.data) return []

  if (type === 'character_response') {
    const entries = typeof content.data === 'string'
      ? parseCharacterStream(content.data)
      : Array.isArray(content.data) ? content.data : []
    return entries.map((_, idx) => mk(idx))
  }

  if (type === 'narrative_response' || type === 'resolution') {
    return [mk(0)]
  }

  return []
}
